import { AgDialog } from '@australiangreens/ag-internal-components';
import { useAtom } from 'jotai';
import { isValidationDialogOpenAtom } from '@/state/searchTemplate/templateValidation';

export {
  isValidationDialogOpenAtom,
  templateValidationErrorsAtom,
  validationErrorsAtom,
  type TemplateValidationError,
} from '@/state/searchTemplate/templateValidation';

export const AdvancedSearchValidationDialog = () => {
  const [isValidationDialogOpen, setIsValidationDialogOpen] = useAtom(isValidationDialogOpenAtom);
  return (
    <AgDialog
      dialogTitle="Warning!"
      isOpen={isValidationDialogOpen}
      onClose={() => setIsValidationDialogOpen(false)}
      secondaryButton={{ text: 'OK' }}
    >
      This search was created using values that no longer exist or are unavailable. Filters with
      missing value(s) will be highlighted.
    </AgDialog>
  );
};
